import type { Testimonial } from '../types/content'

export const testimonials: Testimonial[] = [
  {
    id: 'christian-amador',
    name: 'Christian Amador',
    relationship: { en: 'Family member', es: 'Miembro de la familia' },
    date: { en: '5 months ago', es: 'hace 5 meses' },
    quote: {
      en: 'The agency was great with my grandmother. Very appreciative on how attentive they were when she was with us and in her last days. Would recommend them and use them again.',
      es: 'La agencia fue excelente con mi abuela. Muy agradecido por lo atentos que fueron cuando estuvo con nosotros en sus últimos días. Los recomendaría y los usaría de nuevo.',
    },
    storyTitle: { en: 'Comfort through the final days', es: 'Consuelo en los últimos días' },
    story: {
      en: 'Attentive, gentle care allowed a grandmother to spend her last days at home, surrounded by family who could focus on being together.',
      es: 'Un cuidado atento y amable permitió que una abuela pasara sus últimos días en casa, rodeada de una familia que pudo concentrarse en estar juntos.',
    },
  },
  {
    id: 'm-family',
    name: 'M.',
    relationship: { en: 'Son/Daughter of client', es: 'Hijo/Hija del cliente' },
    date: { en: '2 weeks ago', es: 'hace 2 semanas' },
    quote: {
      en: 'A.M. Homecare, Inc. has been assisting my family with the care of my mother, who is 91 with dementia. I was impressed with the thoroughness of the initial intake process, and how the agency was able to work with the specific schedule of care that was requested. The caregiver is punctual, professional, caring and knowledgeable in all areas requiring care for someone with dementia. I am beyond grateful for this service.',
      es: 'A.M. Homecare, Inc. ha estado asistiendo a mi familia en el cuidado de mi madre, quien tiene 91 años con demencia. Me impresionó la exhaustividad del proceso de admisión inicial, y cómo la agencia pudo trabajar con el horario específico de cuidado que se solicitó. El cuidador es puntual, profesional, cariñoso y conocedor en todas las áreas que requieren cuidado para alguien con demencia. Estoy infinitamente agradecido por este servicio.',
    },
    storyTitle: { en: 'Dementia care on the family’s schedule', es: 'Cuidado de demencia al horario de la familia' },
    story: {
      en: 'A thorough intake and a caregiver matched to a very specific schedule gave a 91-year-old mother consistent, knowledgeable dementia care, and her family real peace of mind.',
      es: 'Un proceso inicial minucioso y una cuidadora adaptada a un horario muy específico dieron a una madre de 91 años un cuidado de demencia constante y experto, y a su familia verdadera tranquilidad.',
    },
  },
  {
    id: 'geriold-maldonado',
    name: 'Geriold Maldonado',
    relationship: { en: 'Family member', es: 'Miembro de la familia' },
    date: { en: '2 weeks ago', es: 'hace 2 semanas' },
    quote: {
      en: 'The company did an amazing job with my grandfather before he passed that we brought them back to care for my grandma as well. Very attentive to both their needs and they even showed us how to care for them when they were not working. Very caring.',
      es: 'La empresa hizo un trabajo increíble con mi abuelo antes de que falleciera, que los traemos de vuelta para cuidar también a mi abuela. Muy atentos a las necesidades de ambos e incluso nos mostraron cómo cuidarlos cuando no estaban trabajando. Muy cariñosos.',
    },
    storyTitle: { en: 'Two generations, one trusted team', es: 'Dos generaciones, un equipo de confianza' },
    story: {
      en: 'After caring for their grandfather, the family invited us back for their grandmother, and our caregivers taught them how to help between visits.',
      es: 'Después de cuidar a su abuelo, la familia nos volvió a llamar para su abuela, y nuestros cuidadores les enseñaron a ayudar entre visitas.',
    },
  },
]
